import AIButton from 'ai-components-ui-library/components/buttons/AIButton';
import AIIconButton from 'ai-components-ui-library/components/buttons/AIIconButton';
import { NOT_USING_TRACKER } from 'ai-components-ui-library/hooks/useTracker';
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useAcademyAssistant } from '../../hooks/useAcademyAssistant';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Fixed-styling entry point for opening the Academy Assistant. If it's
 * already open, this just refocuses the input rather than disrupting the
 * current conversation. If it's closed, it opens (into `mode`, default
 * sidebar) and starts a fresh conversation — sending `initialMessage`
 * immediately when provided, otherwise leaving the input empty for the user.
 *
 * Pass `iconOnly` to render just the Breeze icon (label preserved as the
 * accessible name and tooltip) for tight spaces.
 *
 * For a restylable button that always sends a specific prompt, use
 * `AcademyAssistantActionButton` instead.
 */
export const AskAcademyAssistantButton = ({
  initialMessage,
  mode,
  iconOnly = false
}) => {
  const {
    isOpen,
    open,
    ask,
    startNew,
    focusInput
  } = useAcademyAssistant();
  const handleClick = () => {
    if (isOpen) {
      focusInput();
      return;
    }
    open(mode);
    if (initialMessage) {
      ask(initialMessage);
    } else {
      startNew();
    }
  };
  if (iconOnly) {
    const label = I18n.text('academy-ai-assistant.actions.askButton');
    return /*#__PURE__*/_jsx(AIIconButton, {
      size: "sm",
      usageTracker: NOT_USING_TRACKER,
      "aria-label": label,
      tooltip: label,
      onClick: handleClick
    });
  }
  return /*#__PURE__*/_jsx(AIButton, {
    use: "secondary",
    size: "sm",
    usageTracker: NOT_USING_TRACKER,
    onClick: handleClick,
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "academy-ai-assistant.actions.askButton"
    })
  });
};